// extracted by mini-css-extract-plugin
export default {"root":"breadcrumb_root__cmXh3","crumb":"breadcrumb_crumb__zElhW","link":"breadcrumb_link__o9Gez","separator":"breadcrumb_separator__B-X8i"};